module.exports = __webpack_public_path__ + "static/media/mayron.5b572075.png";